import React, { useState, useEffect, FormEvent } from 'react';

const STAGING_PASSWORD = 'lashbrook';
const SESSION_KEY = 'staging_authenticated';

const StagingGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) === 'true') {
      setAuthenticated(true);
    }
  }, []);

  if (process.env.REACT_APP_ENVIRONMENT !== 'staging') {
    return <>{children}</>;
  }

  if (authenticated) {
    return <>{children}</>;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (password === STAGING_PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      setAuthenticated(true);
    } else {
      setError(true);
    }
  };

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[99999] tw-flex tw-items-center tw-justify-center tw-bg-white">
      <div className="tw-w-full tw-max-w-md tw-px-6 tw-text-center">
        <h1 className="tw-text-3xl tw-font-bold tw-text-[#1e2a3a] tw-mb-4">Staging Access</h1>
        <p className="tw-text-sm tw-text-gray-500 tw-mb-6 tw-leading-relaxed">
          This is Lashbrook&apos;s staging site. The pricing and styles shown here do not reflect current available
          pricing and styles.
        </p>
        <p className="tw-text-sm tw-text-gray-700 tw-mb-4">Enter the password to continue</p>
        <form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-items-center tw-gap-4">
          <div className="tw-relative tw-w-full">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              placeholder="Password"
              className={`tw-w-full tw-border tw-rounded-md tw-px-4 tw-py-3 tw-text-sm tw-text-center tw-outline-none focus:tw-ring-2 focus:tw-ring-[#1e2a3a] ${
                error ? 'tw-border-red-400' : 'tw-border-gray-300'
              }`}
              autoFocus
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2 tw-text-gray-400 hover:tw-text-gray-600 tw-text-xs tw-bg-transparent tw-border-none tw-cursor-pointer"
              tabIndex={-1}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          {error && <p className="tw-text-red-500 tw-text-xs tw--mt-2">Incorrect password</p>}
          <button
            type="submit"
            className="tw-bg-[#1e2a3a] tw-text-white tw-px-10 tw-py-3 tw-rounded-md tw-text-sm tw-font-medium tw-cursor-pointer hover:tw-bg-[#2a3a4e] tw-transition-colors tw-border-none"
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default StagingGate;
